import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'name',
    className: 'bold',
    render: (data, type, row, meta) => renderToString(
      <a href={`/admin/settings/roles/${row.DT_RowId}`}>{data} {row.system_role ? <strong>(system role)</strong> : ''}</a>
    ),
  },
  { data: 'description', render: (data) => renderToString(<span>{data}</span>) },
  { data: 'slug', render: (data) => renderToString(<span>{data}</span>) },
]

const headers = [
  'Name',
  'Description',
  'API name',
]

const filters = []

const sorters = []

const order = [[0, "asc"]]

export { columns, headers, filters, sorters, order }
